import React from 'react'
import axios from 'axios'
import Spinner from '~/components/Spinner'
import './style.scss'

class ProviderList extends React.Component{
    constructor(){
        super()
        this.state = {
            providersList:null,
            loading: true
        }
    }
    componentDidMount(){
        this.fetchProviderList()
    }
    fetchProviderList = () => {
        axios.get('https://mvpd-admin.nbcuni.com/mvpd/service/sprout/prod')
        .then((response) => {
            this.setState({providersList:response.data, loading:false})
        })
        .catch((error) => {
          console.log(error);
        })
    }
    setProvider = (item) => {
        window.AE.setSelectedProvider(item)
    }
    render(){
        if (this.state.loading)
            return (<div className="loading centered"><Spinner/></div>)
        
            return(
            <div className="provider-list">
                <label>Select Your Provider</label>
                <div className="provider-dropdown">
                    <select id="issuerId" className="bank-select" ref={el => this.selectedProvider = el}>
                        <option value="" selected>Select Your Provider</option>
                        {this.state.providersList && this.state.providersList.map((e, i) => {
                            return <option key={i} value={e.field_mvpd_id}>{e.title}</option>;
                        })}
                    </select>
                    <button onClick={ _ => this.setProvider(this.selectedProvider.value) }>GO</button>
                </div>
                <div className="feature-provider">
                    {this.state.providersList && this.state.providersList.map((item, i) => {
                        let isFeature = item.featured === 1 ? true : false
                        return (
                            isFeature && <div className="itemWrapper" key={i} onClick={ _ => this.setProvider(item.field_mvpd_id) }>
                                <img src={item.field_mvpd_logo_light} alt={item.title}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        )
    }
}
 export default ProviderList;
